import Endpoints from "src/constants/endpoints";
import AxiosClient from "src/networking/axios-client/index.client";

import { PrivacyPolicy } from "./index.models";
import { AxiosResponse } from "axios";

class PrivacyPoliciesController {
  async getLatest(): Promise<PrivacyPolicy> {
    const res = await AxiosClient.get({
      url: Endpoints.privacyPolicies,
      parser: (res) =>
        BaseControllerOverviewResposne.fromAxiosResponse<PrivacyPolicy>(res),
    });

    return res.data;
  }

  async getByVersion(version: string): Promise<PrivacyPolicy> {
    const res = await AxiosClient.get({
      url: Endpoints.privacyPolicies,
      queryParams: { version: version },
      parser: (res) =>
        BaseControllerOverviewResposne.fromAxiosResponse<PrivacyPolicy>(res),
    });

    return res.data;
  }
}

class BaseControllerOverviewResposne<T> {
  constructor(public readonly data: T) {}

  static fromAxiosResponse<T>(
    res: AxiosResponse
  ): BaseControllerOverviewResposne<T> {
    return new BaseControllerOverviewResposne(res.data);
  }
}

export default PrivacyPoliciesController;
